import axios from 'axios';
const auth = axios.create({ baseURL : 'http://sqlserver15.lukos.com.br:9013', timeout: 20000 });
//const auth = axios.create({ baseURL : 'http://127.0.0.1:9013'});
export default auth;